var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./withdraw.css";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import _ from "lodash";
import { CurrencyFormat, dateTimeFormat, exceptionModal, gtmCashOut, useForceUpdate, } from "../../services/misc.functions";
import { NewBankAccount } from "../account/account.bank.accounts";
import { toast } from "react-toastify";
import { auth, authSubject } from "../../store/auth.store";
import { isMobile } from "../../App";
import { modalServiceSubject } from "../../services/modal.service";
var withdrawStatusMap = {
    0: {
        label: "Beklemede",
        class: "text-dark",
    },
    1: {
        label: "Ödendi",
        class: "text-success",
    },
    2: {
        label: "İnceleniyor",
        class: "text-danger",
    },
    3: {
        label: "Hatalı",
        class: "text-danger",
    },
    4: {
        label: "İade",
        class: "text-danger",
    },
};
export function Withdraw() {
    var _a, _b;
    var _c = useState([]), accountList = _c[0], setAccountList = _c[1];
    var _d = useState([]), withdrawList = _d[0], setWithdrawList = _d[1];
    var _e = useState(false), newAccountModal = _e[0], setNewAccountModal = _e[1];
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        var auth_subscriber = authSubject.subscribe(function () {
            forceUpdate();
        });
        return function () {
            auth_subscriber.unsubscribe();
        };
    }, []);
    useEffect(function () {
        getWithdrawHistory();
        api
            .start("get", env.accounting_api + "/member/api/list-account/", null, true)
            .then(function (res) {
            if (res && res.status) {
                setAccountList(_.orderBy(res.data, ["id"], ["desc"]));
            }
            else {
                setAccountList([]);
            }
        })
            .catch(function (e) {
            exceptionModal(e);
            setAccountList([]);
        });
    }, []);
    var getWithdrawHistory = function () {
        api
            .start("get", env.accounting_api + "/accounting/api/list-withdraw/", null, true)
            .then(function (res) {
            // console.log(res)
            if (res && res.data) {
                setWithdrawList(res.data);
            }
        });
    };
    var _f = useForm(), register = _f.register, handleSubmit = _f.handleSubmit, reset = _f.reset, setValue = _f.setValue, errors = _f.formState.errors;
    var onSubmit = function (data) {
        var _a;
        // console.log(data);
        if (!auth.member || !((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id)) {
            return toast.error("Lütfen giriş yapınız.");
        }
        if (data.amount === 0) {
            return toast.error("Çekim tutarı 0 olamaz.");
        }
        if (Number(auth.member.balance_debit_available) < Number(data.amount)) {
            return toast.error("Yetersiz Bakiye. Lütfen çekilebilir bakiyenizi kontrol ediniz.");
        }
        var id_submit_withdraw = document.getElementById("id_submit_withdraw");
        if (id_submit_withdraw) {
            id_submit_withdraw.disabled = true;
        }
        api
            .start("post", env.accounting_api + "/accounting/api/create-withdraw-request/", data, true)
            .then(function (res) {
            // console.log(res)
            if (res && res.status) {
                var bank = accountList.find(function (el) { el.id == data.account_id; });
                gtmCashOut(bank.bank_name, data.amount);
                getWithdrawHistory();
                reset({ account_id: -1, amount: "" });
                toast.success(res.message);
            }
            else {
                modalServiceSubject.next({
                    title: "Hata",
                    content: res.message,
                });
            }
        })
            .finally(function () {
            id_submit_withdraw.disabled = false;
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-12 col-md-6 col-lg-7" }, { children: _jsxs("div", __assign({ className: "card withdraw" }, { children: [_jsxs("div", __assign({ className: "card-header" }, { children: [_jsx("h2", { children: "T\u00FCrk Liras\u0131 \u00C7ekim" }), _jsx("p", __assign({ style: { whiteSpace: "normal" } }, { children: "\u00C7ekilebilir T\u00FCrk Liras\u0131 bakiyenizi kendi ad\u0131n\u0131za a\u00E7\u0131lm\u0131\u015F bir banka hesab\u0131na \u00E7ekebilirsiniz. \u015EP puanlar\u0131n\u0131z ile ise \u00F6d\u00FCl katalo\u011Fumuzdan \u00F6d\u00FCl talep edebilirsiniz." }))] })), _jsxs("div", __assign({ className: "card-body pt-3" }, { children: [_jsxs("div", __assign({ className: "row mb-4" }, { children: [_jsx("div", __assign({ className: "col-6" }, { children: _jsxs("div", __assign({ className: "withdraw-total-balance", style: { cursor: "unset", whiteSpace: "normal" } }, { children: ["Toplam TL", isMobile ? _jsx("br", {}) : _jsx(_Fragment, { children: " " }), "Bakiyeniz: ", _jsx("br", {}), _jsxs("strong", { children: [CurrencyFormat(auth.member.balance_debit), " TL"] })] })) })), _jsx("div", __assign({ className: "col-6" }, { children: _jsxs("div", __assign({ className: "btn w-100 btn-outline-primary", style: { cursor: "unset", whiteSpace: "normal" }, onClick: function () {
                                                            setValue('amount', auth.member.balance_debit_available.toString(), { shouldValidate: true });
                                                        } }, { children: ["\u00C7ekilebilir TL", isMobile ? _jsx("br", {}) : _jsx(_Fragment, { children: " " }), "Bakiyeniz: ", _jsx("br", {}), _jsxs("strong", { children: [CurrencyFormat(auth.member.balance_debit_available), " TL"] })] })) }))] })), _jsx("h3", { children: "Para G\u00F6nderilecek Hesap" }), _jsx("p", __assign({ className: "text-secondary", style: { whiteSpace: "normal" } }, { children: "\u00C7ekim i\u015Flemleri sadece sizin ad\u0131n\u0131za a\u00E7\u0131lm\u0131\u015F bir vadesiz hesap i\u00E7in ger\u00E7ekle\u015Ftirilebilir. T\u00FCm bankalardan en az 10 TL \u00E7ekim emri olu\u015Fturabilirsiniz." })), _jsx("div", __assign({ className: "alert alert-warning p-2 mt-3 " }, { children: _jsx("p", __assign({ className: "white-space-normal fs-7" }, { children: "Kredi Kart\u0131 ile yap\u0131lan \u00F6demeler ve para yat\u0131rma iade s\u00FCrecinizle ilgili m\u00FC\u015Fteri hizmetleri temsilcimizden bilgi alabilirsiniz. Kredi kart\u0131 ile yap\u0131lan bakiye y\u00FCklemeleri, \u00E7ekilemez bakiye olarak tan\u0131mlan\u0131r." })) })), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", __assign({ className: "input-group" }, { children: [_jsxs("select", __assign({ className: "form-control" }, register("account_id", { required: true, min: 1 }), { children: [_jsx("option", __assign({ value: -1 }, { children: "Kay\u0131tl\u0131 Hesab\u0131n\u0131z\u0131 Se\u00E7iniz" })), accountList.map(function (el, key) {
                                                                    return (_jsxs("option", __assign({ value: el.id }, { children: [el.bank_name, " ", el.name || "", " ", el.iban] }), "my-account-".concat(key)));
                                                                })] })), _jsx("button", __assign({ className: "btn btn-success", onClick: function () {
                                                                setNewAccountModal(true);
                                                            } }, { children: "Yeni Hesap Ekle" }))] })), _jsx("div", __assign({ className: "clearfix" }, { children: errors.account_id && (_jsx("span", __assign({ className: "text-danger" }, { children: "L\u00FCtfen bir hesap se\u00E7iniz" }))) })), _jsxs("div", __assign({ className: "mt-3" }, { children: [_jsx("label", __assign({ className: "form-label fw-bold mb-1" }, { children: "\u00C7ekilecek Tutar" })), _jsxs("div", __assign({ className: "input-group" }, { children: [_jsx("input", __assign({ type: "number", pattern: "\\d*", inputMode: "decimal", disabled: ((_a = auth.member) === null || _a === void 0 ? void 0 : _a.balance_debit_available) == 0, className: "form-control", min: 0, 
                                                                    // max={auth.member?.balance_debit_available || 1000000}
                                                                    placeholder: "0.00" }, register("amount", { required: true, min: {
                                                                        value: 10,
                                                                        message: "Çekim tutarı en az 10 TL olmalıdır."
                                                                    }, max: {
                                                                        value: ((_b = auth.member) === null || _b === void 0 ? void 0 : _b.balance_debit_available) || 1000000,
                                                                        message: "Çekilebilir bakiyenizden fazla tutar giremezsiniz."
                                                                    } }), { maxLength: 10, step: 0.01 })), _jsx("button", __assign({ id: "id_submit_withdraw", className: "btn btn-success" }, { children: "\u00A0\u00C7ekim Emri Ver\u00A0" }))] })), _jsx("div", { className: "clearfix" }), errors.amount && (_jsx("span", __assign({ className: "text-danger" }, { children: errors.amount.message || "Lütfen geçerli bir tutar giriniz." })))] }))] }))] }))] })) })), _jsx("div", __assign({ className: "col-12 col-md-6 col-lg-5 mt-sm-2" }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: "\u00C7ekim Ge\u00E7mi\u015Fi" }) })), _jsxs("div", __assign({ className: "card-body" }, { children: [withdrawList.length === 0 && (_jsx("p", __assign({ className: "text-center" }, { children: "\u00C7ekim Talebiniz Bulunmamaktad\u0131r" }))), withdrawList.length > 0 && (_jsxs("table", __assign({ className: "table table-striped" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ scope: "col" }, { children: "Tarih" })), _jsx("th", __assign({ scope: "col" }, { children: "Tutar" })), _jsx("th", __assign({ scope: "col" }, { children: "Durum" }))] }) }), _jsx("tbody", { children: withdrawList.map(function (el, key) {
                                                        return (_jsxs("tr", { children: [_jsx("td", { children: dateTimeFormat(el.create_date) }), _jsxs("td", { children: [el.amount, "\u20BA"] }), _jsx("td", { children: _jsx("span", __assign({ className: "".concat(withdrawStatusMap[el.status].class) }, { children: withdrawStatusMap[el.status].label })) })] }, "withdraw-".concat(key)));
                                                    }) })] })))] }))] })) }))] })), _jsx(NewBankAccount, { setNewAccountModal: setNewAccountModal, setAccountList: setAccountList, newAccountModal: newAccountModal })] }));
}
